{
  "title": "如何審核學生資格驗證",
  "description": "在「人員與角色」頁的「資格驗證」分頁審核學生上傳的在學證明，通過或退回。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作路徑",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，該名學生的資格驗證狀態會更新為「已通過」或「未通過」，並立即反映在學生自己的畫面上。",
  "roleNote": "競賽管理員（Competition Admin）",
  "prerequisites": [
    "該場競賽已開啟「學生資格驗證」政策，且已有學生上傳在學證明",
    "你的帳號在該場競賽具備「資格驗證」權限（預設僅競賽管理員擁有，一般工作人員 Staff 預設不具備）"
  ],
  "pathLabel": "主辦方後台 → 我的競賽 → 營運 → 資格驗證審核（或：人員與角色 → 資格驗證分頁，兩者為同一份工作台）",
  "steps": [
    {
      "title": "1. 開啟「資格驗證」分頁",
      "description": "進入指定競賽的「人員與角色」頁後，若你具備審核權限，畫面上方會出現「成員」與「資格驗證」兩個分頁，點選「資格驗證」。頁面最上方會先顯示已通過、待審核、未通過三塊統計磚。"
    },
    {
      "title": "2. 篩選要處理的成員",
      "description": "使用狀態、隊伍 ID、姓名／Email／學校關鍵字三個篩選條件縮小清單範圍；篩選條件會同步寫入網址，方便之後直接分享或返回同一個篩選結果。"
    },
    {
      "title": "3. 開啟審核視窗",
      "description": "在清單中找到要處理的成員，點擊該列的「審核」按鈕開啟審核視窗，視窗會顯示該成員的姓名、隊伍、學校、系所，以及已上傳的證明檔案。"
    },
    {
      "title": "4. 預覽或下載證明檔案",
      "description": "在審核視窗中可線上預覽或下載該成員上傳的證明檔案原始內容，確認文件是否符合要求後再做決定。"
    },
    {
      "title": "5. 選擇審核結果並送出",
      "description": "選擇「通過」或「未通過」；選擇「未通過」時必須填寫退回原因（自由文字），否則無法送出。確認後點擊「確認審核」，審核結果會立即生效。選擇「未通過」時，畫面會事先提示：系統會以 Email 通知該學生，內容包含您填寫的原因，請留意措辭；選擇「通過」時不會寄信。"
    }
  ],
  "afterward": [
    "該成員的資格驗證狀態立即更新為「已驗證」或「已退回」",
    "若為「已退回」，該學生會收到 Email 通知並附上您填寫的退回原因，登入後也會在自己的「學生資格驗證」頁看到原因並可自行重新上傳，不需要您另外通知或再次操作；這封通知信的寄送成功或失敗會記錄在稽核紀錄",
    "「資格驗證」分頁上方的統計磚會同步反映最新的通過／待審核／未通過人數"
  ],
  "nextSteps": "若想在不進行審核動作的情況下查看整體或歷史資格驗證資料，可改前往「資格驗證資料」頁面查看唯讀的彙總與明細。",
  "faq": [
    {
      "q": "工作人員（Staff）可以審核資格驗證嗎？",
      "a": "預設不行。資格驗證審核權限（eligibility.review）預設只授予競賽管理員（Competition Admin），一般工作人員角色預設不具備此權限，畫面上也不會顯示「資格驗證」分頁。"
    },
    {
      "q": "成員還沒上傳任何證明，會出現在清單中嗎？",
      "a": "不會。資格驗證紀錄要等該成員第一次上傳證明後才會建立，因此完全沒有上傳過的成員不會出現在這份清單裡；統計磚下方也會提示「未提交」人數目前無法統計。"
    },
    {
      "q": "審核視窗中沒有「未通過」的原因欄位，可以送出嗎？",
      "a": "不行。選擇「未通過」時系統會要求必填退回原因，未填寫時「確認審核」按鈕會維持無法點擊的狀態。"
    }
  ]
}
